import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorManagementNotificationSearch = () => {
  const managementNotificationSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/management/notification/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { managementNotificationSearch }
}

export default InteractorManagementNotificationSearch
